import { type FunctionComponent } from 'react';
import { PLACEHOLDER_OPTIONS } from '../../../../constants/cloudinary/general';
import { HOME_SPLASH_OPTIONS } from '../../../../constants/home/general';
import { type CloudinaryOptions } from '../../../../helpers/cloudinary-helper/cloudinary-helper';
import type { NormalizedConstructImage } from '../../../../helpers/construct/page-content.helper';
import { Link } from '../../../common-components/link/link.component';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';

export type MainImageProps = {
	background: NormalizedConstructImage;
	options?: CloudinaryOptions;
	url: string;
	analyticsHook: string;
};

export const MainImage: FunctionComponent<MainImageProps> = ({ background, options = HOME_SPLASH_OPTIONS, url, analyticsHook }) => {
	return (
		<Link className="flex" url={url} analyticsHook={analyticsHook} ariaLabel="background">
			<CloudinaryImage
				description={background.description}
				publicID={background.id}
				className="h-auto"
				options={options}
				useDimensions={true}
				placeholderOptions={{
					...HOME_SPLASH_OPTIONS,
					...PLACEHOLDER_OPTIONS
				}}
				lowQualityPlaceholder={background.lowQualityPlaceholder}
				bypassLazyLoad={true}
				actualImageProps={{ fetchPriority: 'high' }}
			/>
		</Link>
	);
};
